import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',

    '& b': {
      fontSize: 34,
      fontWeight: 'bold',
    },
  },
  steps: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(4),

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
    },
  },
  stepItem: {
    width: 300,
  },
  stepVideo: {
    width: 270,
    marginBottom: theme.spacing(1),
  },
  stepIcon: {
    margin: theme.spacing(2, 0),
    fontSize: theme.typography.h3.fontSize,
    color: '#7833FF',

    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(7),
      marginBottom: 0,
      transform: 'rotate(-90deg)',
    },
  },
  button: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
    backgroundColor: '#7833FF',

    '&:hover': {
      backgroundColor: '#5F29CC',
    },
  },
  stepSubTitle: {
    fontSize: 16,
  },
}));
